import { createStore, applyMiddleware } from "redux";
import allReducers from "../Reducers";

import reduxThunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import routemiddleware from "../middleware/route-middleware";

const store = createStore(
  allReducers,
  composeWithDevTools(applyMiddleware(reduxThunk))
);

export default store;
